
import axios from '../../helpers/axios';


export const updatedPickupPoints = (id, updatePickupPoints) => axios.patch(`/pickupPoints/update/${id}`, updatePickupPoints)
export const deletedPickupPoints = (id) => axios.delete(`/pickupPoints/delete/${id}`)
